import { slateComponentGQLFields } from './slateComponent.fields.js';
import { slatePlaceholderGQLFields } from './slatePlaceholder.fields.js';
export const slateGQLFields = (fields) => `
  id
  rootComponents
  components {
    ... on SlatePlaceholder {
      ${slatePlaceholderGQLFields(fields)}
    }
    ... on SlateComponent {
      ${slateComponentGQLFields(fields)}
    }
  }
`;
//# sourceMappingURL=slate.fields.js.map